const ActivatedTabKeys = {
  GeneralSettings: 'GeneralSettingsTab',
  ContentNIntegrity: 'ContentNIntegrityTab',
  Image: 'ImageAnalyticsTab',
  StaticMalwareScan: 'StaticMalwareScanTab',
  NLPEngine: 'NLPEngineTab',
  PreviewHTML: 'PreviewHTMLTab',
  PreviewBaselineImage: 'PreviewBaselineImageTab',
  VideoDefacementEngine: 'VideoDefacementEngineTab',
  AiTriageRules: 'AiTriageRulesTab',
};

/** Default tblUserAgent id for new webpages, domains, and crawls (Chrome 140). */
const DEFAULT_USER_AGENT_ID = 903;

const BASELINE_SCREENSHOT_MISSING =
  'Baseline screenshot could not be loaded. Please rebaseline to capture the screenshot again.';
const BASELINE_SCREENSHOT_NOT_FOUND =
  'Baseline screenshot not found. The webpage may not have been baselined yet.';
const BASELINE_SCREENSHOT_LOAD_FAILED =
  'Failed to load baseline screenshot. Please try again.';

export {
  ActivatedTabKeys,
  DEFAULT_USER_AGENT_ID,
  BASELINE_SCREENSHOT_MISSING,
  BASELINE_SCREENSHOT_NOT_FOUND,
  BASELINE_SCREENSHOT_LOAD_FAILED,
};
